import { post } from './request';

// 获取问卷信息
export var submit = function submit(data) {
  return post('/answer/submit_question', data);
};